module.exports = __webpack_public_path__ + "static/media/Tonometry.6663f553.gif";